export enum StaticAction {
  PEND = 1,
  ASSIGN = 2,
  RELEASE_LOCK = 3,
  FINISH = 4,
  AUTO_ASSIGN = 5,
}
